export default function findById(id, items, errorText) {
    const result = items.find((item) => item.id === id);
    if (result == null)
        throw new Error(errorText ?? `Failed to find item with id ${id}`);
    return result;
}
//# sourceMappingURL=findById.js.map